import * as React from "react";
import * as _ from "lodash";
import {translate} from 'react-i18next';

// service
import {ResourceListOfModelyearDto, ModelyearDto} from "../../services/Client";

// reducer
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";

// semantic
import {Tab, TabProps} from "semantic-ui-react";

import Button from "../../components/Button";
import Dialog from "../../components/Dialogs/Dialog";
import ModelYearsControl from "../../components/ModelYearsControl";
import ModelyearCopyControl from "./ModelyearCopyControl";

export interface IModelyearSelectDialogProps extends ITranslatedComponent {
    /** Active tab index in the dialog. */
    activeIndex?: number;

    /** All model years available in the dialog. */
    modelyears: ResourceListOfModelyearDto;

    /** Pre-selected model year. */
    selectedItem?: ModelyearDto;

    /** Call back method for when the user has cosen a model year to load. */
    onLoadModelYear?: (dto: ModelyearDto) => any;

    /** Call back method for when the user has cosen a source and destination model year for copying. */
    onCopyModelyear?: (src: ModelyearDto, dst: ModelyearDto) => any;

    /** Close dialog without return value. */
    onClose?: () => any;
}

interface IModelyearSelectDialogState {
    /** Active tab index. */
    activeIndex: number;

    /** The selected item for loading. */
    selectedItem?: ModelyearDto;

    /** The selected source item for copying. */
    srcItem?: ModelyearDto;

    /** The selected destination item for copying. */
    dstItem?: ModelyearDto;
}

export class ModelyearSelectDialog extends React.Component<IModelyearSelectDialogProps, IModelyearSelectDialogState> {
    constructor(props: IModelyearSelectDialogProps) {
        super(props);

        let selectedModelyear = undefined;
        const {modelyears, selectedItem} = props;
        if (modelyears.elements && selectedItem !== undefined) {
            selectedModelyear = _.find(modelyears.elements, dto => (dto.objectId === selectedItem.objectId));
        }
        this.state = {
            activeIndex: props.activeIndex || 0,
            selectedItem: selectedModelyear,
            srcItem: undefined,
            dstItem: undefined,
        };
    }

    onClickOk = () => {
        const {onLoadModelYear, onCopyModelyear} = this.props;
        const {activeIndex, selectedItem, srcItem, dstItem} = this.state;

        if (activeIndex === 0 && onLoadModelYear) {
            if (selectedItem) {
                onLoadModelYear(selectedItem);
            }
        } else if (activeIndex === 1 && onCopyModelyear) {
            if (srcItem && dstItem && this.isSelectionValid(srcItem, dstItem)) {
                onCopyModelyear(srcItem, dstItem);
            }
        }
    }

    renderModelyearSelection = (): JSX.Element => (
        this.props.modelyears.elements && this.props.modelyears.elements.length > 0 ?
            (
                <ModelYearsControl
                    id="modelyear_select"
                    modelyears={this.props.modelyears}
                    selectedItem={this.state.selectedItem}
                    selectionChanged={(dto: ModelyearDto) => this.setState({selectedItem: dto})}
                />
            )
            : <>{this.props.t("MISSING_ACCESS_RIGHTS")}</>
    )

    renderModelyearCopy = (): JSX.Element => (
        this.props.modelyears.elements && this.props.modelyears.elements.length > 0 ?
            (
                <ModelyearCopyControl
                    modelyears={this.props.modelyears}
                    srcItem={this.state.srcItem}
                    dstItem={this.state.dstItem}
                    selectionChanged={(src?: ModelyearDto, dst?: ModelyearDto) => this.setState({srcItem: src, dstItem: dst})}
                />
            )
            : <>{this.props.t("MISSING_ACCESS_RIGHTS")}</>
    )

    isSelectionValid = (src?: ModelyearDto, dst?: ModelyearDto): boolean => {
        if (src !== undefined && dst !== undefined) {
            return src.mj1 !== dst.mj1;
        }
        return false;
    }

    createDialogActions = (): JSX.Element[] => ([
        (
            <Button
                key={"submitButton"}
                icon={"checkmark"}
                id="modelyear_submit"
                disabled={
                    (this.state.activeIndex === 0 && !this.state.selectedItem)
                    ||
                    (this.state.activeIndex === 1 && !this.isSelectionValid(this.state.srcItem, this.state.dstItem))
                }
                onClick={this.onClickOk}
            />
        ), (
            <Button
                id="modelyear_close"
                key={"closeButton"}
                icon={"ban"}
                onClick={this.props.onClose}
            />
        ),
    ])

    createTabs = (): any[] => {
        // see TabProps.panes for the exact type.
        const panes: any[] = [];
        panes.push({
            menuItem: this.props.t("LOAD_BASEOPTIONS"),
            render: () => (
                <Tab.Pane attached={false}>
                    {this.renderModelyearSelection()}
                </Tab.Pane>
            )
        });
        if (this.props.onCopyModelyear) {
            // show the copy tab only if the user has sufficient privileges
            panes.push({
                menuItem: this.props.t("COPY_BASEOPTIONS"),
                render: () => (
                    <Tab.Pane attached={false}>
                        {this.renderModelyearCopy()}
                    </Tab.Pane>
                )
            });
        }
        return panes;
    }

    render() {
        return (
            <Dialog
                open={true}
                actions={this.createDialogActions()}
            >
                <Tab
                    panes={this.createTabs()}
                    defaultActiveIndex={this.state.activeIndex}
                    onTabChange={(event: React.MouseEvent<HTMLDivElement>, data: TabProps) => {
                        this.setState({activeIndex: data.activeIndex as number});
                    }}
                />
            </Dialog>
        );
    }
}

export default translate("BASEOPTIONS")(ModelyearSelectDialog);



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/ModelyearSelectDialog.tsx